export { default } from './ArticleInfoItem';
